export default __webpack_public_path__ + "static/media/poi.6fd3be5d.svg";